import { useParams } from "react-router";
import { useRelationshipsRelationshipShowQuery } from "@/services/backend/relationships/api/service";
import { CommitmentCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/commitment-card";
import { DocumentCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/document-card";

export function DataRoute() {
  const { relationshipId, commitmentId } = useParams();

  const { data: relationship } = useRelationshipsRelationshipShowQuery({
    id: relationshipId!,
  });

  const commitment = relationship?.commitments.find(
    (c) => c.id === commitmentId,
  );

  // If relationship or commitment do not exist, the CommitmentRoute will
  // catch it.

  return (
    <div className="grid gap-2">
      <CommitmentCard commitment={commitment!} />
      <DocumentCard relationship={relationship!} commitment={commitment!} />
    </div>
  );
}
